import { AuthRoutes } from "./public/auth.routes";

export const PublicRoutes = [
	...AuthRoutes
];
